import { useEffect, useState } from "react";
import { CheckBox } from "../../components/checkBox/CheckBox";
import { TextField } from "../../components/fields/Fields";
import { SelectFields } from "../../components/select/SelectFields";
import FormController from "../../components/fields/FormController";
import Button from "../../components/button/Button";
import { CheckBoxItem } from "../../components/checkBox/CheckBoxGroup";
import { SearchUserList, UserData, UserListSearchDefault } from "../../model/Users";
import { MagnifyingGlassIcon, ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { auth } from "../../firebase";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { Groups } from "../../model/Groups";
import { GroupSelectModal } from "../userList/GroupSelectModal";
import Badge from "../../components/badges/Badges";
import { SearchKeysEditModal } from "../searchKeys/SearchKeysEditModal";
import companiesQuery from "../../firestore/Companies.query";
import { Company } from "../../model/Companies";
import { SearchKeys} from "../../model/SearchKeys";

type Props = {
  userList: UserData[];
  setSearchUserList: Function;
  setSearchUserListFlg: Function;
  groupList: Groups[];
  searchKey1List: { value: string; disabled: boolean; }[];
  searchKey2List: { value: string; disabled: boolean; }[];
  searchKey3List: { value: string; disabled: boolean; }[];
  companyData?: Company;
  setIsUpdateSearchKeys: React.Dispatch<React.SetStateAction<boolean>>;
  onSearch: (searchCondition: any) => void;
  searchCondition: any;
};
  
export const UserListSearch = ({
  groupList,
  searchKey1List,
  searchKey2List,
  searchKey3List,
  companyData,
  setIsUpdateSearchKeys,
  onSearch,
}:Props) => {
  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;
  const dispatch = useDispatch();

  const [userListResult, setUserListResult] = useState<SearchUserList>(UserListSearchDefault);
  const [searchFlg, setSearchFlg] = useState(true);
  const [searchKeysOneList, setSearchKeysOneList] = useState([]);
  const [searchKeysTwoList, setSearchKeysTwoList] = useState([]);
  const [searchKeysThreeList, setSearchKeysThreeList] = useState([]);
  const [checkedValue, setCheckedValue] = useState("");
  const [isOpenGroupSelect, setIsOpenGroupSelect] = useState(false);
  const [isVoid, setIsVoid] = useState(false);
  const [companyGroupsValue, setCompanyGroupsValue] = useState<CheckBoxItem[]>([]);
  const [selectedGroups, setSelectedGroups] = useState<CheckBoxItem[]>([]);
  const errorMessage = ConstMessage.ERR_USERID_LENGTH;
  const [userIdError, setUserIdError] = useState(false);
  const { control } = useForm<UserData & {topicLength: number}>({});
  const [isSearchKeysEditModalOpen, setIsOpen] = useState(false);
  const [groupSelectError, setGroupSelectError] = useState("");

  // アイコン設定
  const searchIcon = {icon: MagnifyingGlassIcon};
  const upIcon = {icon: ChevronUpIcon};
  const downIcon = {icon: ChevronDownIcon};

  // 初期表示
  useEffect(() => {
    const f = async () => {
      try{
        // 検索キー１プルダウン
        let searchKeysOneList:any = [
          {id:"", name:""},
          {id:"notSet", name:"＜未設定＞"},
        ];
        if(!(Object.keys(searchKey1List).length == 1 && searchKey1List[0].value == "")){
          searchKey1List.map((searchKey1) => {
            if(searchKey1.value != undefined){
              searchKeysOneList.push({id:searchKey1.value, name:searchKey1.value});
            }
          })
        }
        setSearchKeysOneList(searchKeysOneList)
        // 検索キー２プルダウン
        let searchKeysTwoList:any = [
          {id:"", name:""},
          {id:"notSet", name:"＜未設定＞"},
        ];
        if(!(Object.keys(searchKey2List).length == 1 && searchKey2List[0].value == "")){
          searchKey2List.map((searchKey2) => {
            if(searchKey2.value != "undefined"){
              searchKeysTwoList.push({id:searchKey2.value, name:searchKey2.value});
            }
          })
        }
        setSearchKeysTwoList(searchKeysTwoList)
        // 検索キー３プルダウン
        let searchKeysThreeList:any = [
          {id:"", name:""},
          {id:"notSet", name:"＜未設定＞"},
        ];
        if(!(Object.keys(searchKey3List).length == 1 && searchKey3List[0].value == "")){
          searchKey3List.map((searchKey3) => {
            if(searchKey3.value != "undefined"){
              searchKeysThreeList.push({id:searchKey3.value, name:searchKey3.value});
            }
          })
        }
        setSearchKeysThreeList(searchKeysThreeList)
      }catch(err: any){
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
    };
    f();
  },[searchKey1List, searchKey2List, searchKey3List]);

  // グループセレクト画面の初期表示用
  useEffect(() => {
    const f = async () => {
        const defaultGroupsValue = groupList? await Promise.all(groupList.map((item): CheckBoxItem => {
          return {
            id: item.id,
            title: item.name,
            value: false,
            disabled: item.deleteFlg,
          }
        })): [];
        setCompanyGroupsValue(defaultGroupsValue);
        setSelectedGroups(defaultGroupsValue);
    };
    f();
  },[groupList]);

  useEffect(() => {
    console.log("changed message search");
  },[searchFlg, ]);

  // 検索画面の表示・非表示の切り替え
  const handleClick = (e:any) => {
    e.preventDefault();
    setSearchFlg(searchFlg? false : true);
  };

  //チェックボックス（textフォーム）の値を管理
  const changedCheckBox = (e:any, value:string) => {
    setUserListResult({...userListResult, name: "", zipCode: "", address: ""});
    setCheckedValue(value);
  }

  // 性別プルダウン
  const sexList = 
    [
      {id:"", name:""},
      {id:"notSet", name:"＜未設定＞"},
      {id:"male", name:"男"},
      {id:"female", name:"女"},
      {id:"others", name:"その他"},
    ];
  // ログインプルダウン
  const loginList = 
    [
      {id:"", name:""},
      {id:"yet", name:"未"},
      {id:"done", name:"済"},
    ];
  // 役割プルダウン
  const roleList = 
    [
      {id:"", name:""},
      {id:"notSet", name:"＜未設定＞"},
      {id:"user", name:"利用者"},
      {id:"admin", name:"運営者"},
    ];
  // アプリ利用プルダウン
  const appUsageList = 
    [
      {id:"", name:""},
      {id:"notSet", name:"＜未設定＞"},
      {id:"available", name:"利用可"},
      {id:"notAvailable", name:"利用不可"},
      {id:"suspension", name:"停止"},
    ];

  // グループセレクト画面の表示用
  useEffect(() => {
    const f = async () => {
      setIsVoid(!isVoid);
      if(companyGroupsValue.length > 0){
        let topic: any = [];
        await Promise.all(companyGroupsValue.map((item: any) => {
          if(item.value){
            const value = item.value;
            topic.push({id:item.id, title: item.title});
          }
        }));
        setUserListResult({...userListResult, topic:topic});
      }
    };
    f();
  },[isOpenGroupSelect]);

  const toggle = () => {
    if (companyGroupsValue.filter((group) => group.value === true).length > 30) {
      setGroupSelectError(ConstMessage.ERR_GROUP_SELECT_31_OR_MORE);
    } else {
      setGroupSelectError('');
      setSelectedGroups(companyGroupsValue);
      setIsOpenGroupSelect(!isOpenGroupSelect);
      setIsVoid(!isVoid);
    }
  };

  const onSelectCancel = () => {
    // 変更前のグループ選択状態をセット
    setCompanyGroupsValue(selectedGroups);
    setUserListResult({...userListResult, topic: []});
    setIsOpenGroupSelect(!isOpenGroupSelect);
    setIsVoid(!isVoid);
  }

  // 検索を実行
  const onClickSearch = async () => {
    if (userListResult.userId && userListResult.userId.trim() !== "") {
      const regexp = /^[0-9]{11}$/;
      if (!regexp.test(userListResult.userId)) {
        setUserIdError(true);
        return;
      } else {
        setUserIdError(false);
      }
    } else {
      setUserIdError(false);
    }
    const searchCondition = {
      userId: userListResult.userId,
      sex:
        userListResult.sex === "male"
          ? 0
          : userListResult.sex === "female"
          ? 1
          : userListResult.sex === "others"
          ? 2
          : userListResult.sex === "notSet"
          ? "notSet"
          : "",
      birthDateStart: userListResult.birthDateStart,
      birthDateEnd: userListResult.birthDateEnd,
      name: checkedValue === "name" ? userListResult.name : "",
      zipCode: checkedValue === "zipCode" ? userListResult.zipCode : "",
      address: checkedValue === "address" ? userListResult.address : "",
      login: userListResult.login,
      admin:
        userListResult.role === "admin"
          ? true
          : userListResult.role === "user"
          ? false
          : userListResult.role === "notSet"
          ? "notSet"
          : "",
      deleteFlg:
        userListResult.appUsage === "available"
          ? false
          : userListResult.appUsage === "notAvailable"
          ? true
          : userListResult.appUsage === "notSet"
          ? "notSet"
          : "",
      accountSuspensionFlg:
        userListResult.appUsage === "suspension"
          ? true
          : false,
      searchKey1:
        userListResult.searchKey1 === "notSet"
          ? "notSet"
          : userListResult.searchKey1,
      searchKey2:
        userListResult.searchKey2 === "notSet"
          ? "notSet"
          : userListResult.searchKey2,
      searchKey3:
        userListResult.searchKey3 === "notSet"
          ? "notSet"
          : userListResult.searchKey3,
      groups: Array.isArray(userListResult.topic)
        ? userListResult.topic.map((g: any) => g.id)
        : [],
    };

    onSearch(searchCondition);
  };

  // 検索キー設定モーダル開閉
  const searchKeysToggle = () => {
    setIsOpen(!isSearchKeysEditModalOpen);
  };
  const onSearchKeysEdit = () => {
    searchKeysToggle();
  }
  const [searchKeys, setSearchKeys] = useState<any[]>([]);
  useEffect(() => {
    if (isSearchKeysEditModalOpen) {
      const fetchSearchKey = async () => {
        let searchKeys:SearchKeys[] =[];
        if (companyData?.id) {
          searchKeys = await companiesQuery.getSearchKeys(companyData.id);
        }
        setSearchKeys(searchKeys);
      };
      fetchSearchKey(); 
    }
  }, [isSearchKeysEditModalOpen]); 

  return(
    <div className="flex flex-col">
      {/* 検索キー設定モーダル */}
      {isSearchKeysEditModalOpen && (<SearchKeysEditModal
        open={isSearchKeysEditModalOpen}
        toggle={searchKeysToggle}
        closeOnClickOutside={true}
        children={undefined}
        searchKey={searchKeys}
        tenantId={currentUser?.tenantId ?? ""}
        setIsUpdateSearchKeys={setIsUpdateSearchKeys}
      />)}
      <div className="">
        <div className="inline-block min-w-full p-1 align-middle">
          <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table className="min-w-full divide-y">
              <div className="sm:items-center p-2">
                <div className="flex justify-between cursor-pointer" onClick={(e) => handleClick(e)}>
                  <h2 className=" flex font-semibold text-gray-900 items-center">
                    <searchIcon.icon
                      className={"flex-shrink-0 h-5 w-5"}
                      aria-hidden="true"
                    />
                    検索
                  </h2>
                  {searchFlg?(
                    <>
                      <upIcon.icon
                        className={"flex-shrink-0 h-5 w-5"}
                        aria-hidden="true"
                      />
                    </>
                  ):(
                    <>
                      <downIcon.icon
                        className={"flex-shrink-0 h-5 w-5"}
                        aria-hidden="true"
                      />
                    </>
                  )}
                </div>
                <div className="pr-20 flex flex-wrap max-w-[100%]">
                  {searchFlg?(
                    <>
                    <div className="flex min-w-full">  
                      <table className="min-w-full">
                        {/* 検索条件上段 */}
                        <tr className="min-w-full">
                          {/* 利用者番号等の検索 */}
                          <td className="w-[27%]">
                            <div className="mt-4">
                              <div className="flex sm:items-center justify-start flex-1 flex-wrap">
                                <h3 className="text-sm text-gray-500 mb-3">&nbsp;複数項目を入力した場合はAND検索となります</h3>
                              </div>
                              <div className="ml-4 flex sm:items-center justify-start flex-1 flex-wrap">
                                <h3 className="text-sm text-gray-900">利用者番号　</h3>&nbsp;
                                <div className="w-1/10">
                                  <TextField
                                    id="userId"
                                    className={'h-full w-48'}
                                    inputClassName={`h-8`}
                                    value={userListResult.userId}
                                    error={userIdError}
                                    helperText={errorMessage}
                                    onChange={(e:any) => setUserListResult({...userListResult, userId:e.target.value})}
                                  />
                                </div>
                              </div>
                              <div className="ml-4 mt-1 flex sm:items-center justify-start flex-1 flex-wrap">
                                <h3 className="text-sm text-gray-900">性別　　　　</h3>&nbsp;
                                <div className="w-1/10">
                                  <SelectFields
                                    id="sex"
                                    color="indigo"
                                    value={userListResult.sex}
                                    className={"h-10 w-48"}
                                    selectItems={sexList}
                                    onChange={(e:any) => setUserListResult({...userListResult, sex:e.target.value})}
                                  />
                                </div>
                              </div>
                              <div className="ml-4 flex sm:items-center justify-start flex-wrap">
                                <h3 className="text-sm text-gray-900">生年月日　　</h3>&nbsp;
                                <div className="flex items-center w-2/10">
                                  <FormController
                                    control={control}
                                    value={userListResult.birthDateStart}
                                    className={"h-10"}
                                    inputClassName={`h-8`}
                                    name={"birthDate_s"}
                                    label={""}
                                    onChange={(e:any) => setUserListResult({...userListResult, birthDateStart: e.target.value})}
                                    type={"date"}
                                  />
                                  ～
                                  <FormController
                                    control={control}
                                    value={userListResult.birthDateEnd}
                                    className={"h-10"}
                                    inputClassName={`h-8`}
                                    name={"birthDate_e"}
                                    label={""}
                                    onChange={(e:any) => setUserListResult({...userListResult, birthDateEnd: e.target.value})}
                                    type={"date"}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                          {/* 前方一致検索 */}
                          <td className="pl-3 w-[27%]">
                            <div className="pt-4">
                              <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                <table className={`table-fixed `}>
                                  <div className="sm:items-center p-2">
                                    <h3 className="text-sm text-gray-500 mb-3 ml-2">前方一致検索 ※いずれか１つの項目を選択してください</h3>
                                    <div className="ml-3 flex sm:items-center justify-start flex-wrap">
                                      <h3 className="text-sm text-gray-900">名前　　</h3>&nbsp;
                                      <div className="flex items-center w-2/10">
                                        <CheckBox
                                          id="name"
                                          value={checkedValue == "name" ? true : false}
                                          onChange={(e:any) => changedCheckBox(e, checkedValue == "name"? "" : "name")}
                                        />
                                        <TextField
                                          id=""
                                          className={'h-10 w-44'}
                                          inputClassName={`${checkedValue == "name" ? "" : "bg-gray-300"} h-8`}
                                          value={userListResult.name}
                                          disabled={checkedValue == "name" ? false : true}
                                          onChange={(e:any) => setUserListResult({...userListResult, name:e.target.value})}
                                        />
                                      </div>
                                    </div>
                                    <div className="ml-3 flex sm:items-center justify-start flex-wrap">
                                      <h3 className="text-sm text-gray-900">郵便番号</h3>&nbsp;
                                      <div className="flex items-center w-2/10">
                                        <CheckBox
                                          id="zipCode"
                                          value={checkedValue == "zipCode" ? true : false}
                                          onChange={(e:any) => changedCheckBox(e, checkedValue == "zipCode"? "" : "zipCode")}
                                        />
                                        <TextField
                                          id=""
                                          className={'h-10 w-44'}
                                          inputClassName={`${checkedValue == "zipCode" ? "" : "bg-gray-300"} h-8`}
                                          value={userListResult.zipCode}
                                          disabled={checkedValue == "zipCode" ? false : true}
                                          onChange={(e:any) => setUserListResult({...userListResult, zipCode:e.target.value})}
                                        />
                                      </div>
                                    </div>
                                    <div className="ml-3 flex sm:items-center justify-start flex-wrap">
                                      <h3 className="text-sm text-gray-900">住所　　</h3>&nbsp;
                                      <div className="flex items-center w-2/10">
                                        <CheckBox
                                          id="address"
                                          value={checkedValue == "address" ? true : false}
                                          onChange={(e:any) => changedCheckBox(e, checkedValue == "address"? "" : "address")}
                                        />
                                        <TextField
                                          id=""
                                          className={'h-10 w-44'}
                                          inputClassName={`${checkedValue == "address" ? "" : "bg-gray-300"} h-8`}
                                          value={userListResult.address}
                                          disabled={checkedValue == "address" ? false : true}
                                          onChange={(e:any) => setUserListResult({...userListResult, address:e.target.value})}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </table>
                              </div>  
                            </div>
                          </td>
                          {/* ログイン等検索 */}
                          <td className="pl-6 w-[20%]">
                            <div className="mt-12">
                              <div className="flex sm:items-center justify-start flex-1 flex-wrap">
                                <h3 className="text-sm text-gray-900">ログイン　</h3>&nbsp;
                                <div className="w-1/10">
                                  <SelectFields
                                    id="login"
                                    color="indigo"
                                    value={userListResult.login}
                                    className={"h-10 w-48"}
                                    selectItems={loginList}
                                    onChange={(e:any) => setUserListResult({...userListResult, login:e.target.value})}
                                  />
                                </div>
                              </div>
                              <div className="flex sm:items-center justify-start flex-1 flex-wrap">
                                <h3 className="text-sm text-gray-900">役割　　　</h3>&nbsp;
                                <div className="w-1/10">
                                  <SelectFields
                                    id="role"
                                    color="indigo"
                                    value={userListResult.role}
                                    className={"h-10 w-48"}
                                    selectItems={roleList}
                                    onChange={(e:any) => setUserListResult({...userListResult, role:e.target.value})}
                                  />
                                </div>
                              </div>
                              <div className="flex sm:items-center justify-start flex-1 flex-wrap">
                                <h3 className="text-sm text-gray-900">アプリ利用</h3>&nbsp;
                                <div className="w-1/10">
                                  <SelectFields
                                    id="appUsage"
                                    color="indigo"
                                    value={userListResult.appUsage}
                                    className={"h-10 w-48"}
                                    selectItems={appUsageList}
                                    onChange={(e:any) => setUserListResult({...userListResult, appUsage:e.target.value})}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                          {/* 検索キー1,2,3検索 */}
                          <td className="pl-4 w-[20%]">
                              <div className="flex justify-end">
                                <div>
                                  <Button
                                    className={"h-10 text-sm sm:items-center"}
                                    onClick={() => onSearchKeysEdit()}
                                    children={"検索キー設定"}
                                  />
                                </div>
                              </div>
                            <div className="flex justify-end">
                              <div className="flex justify-end flex-wrap">
                                <div className="flex ml-1 mt-2 sm:items-center flex-wrap">
                                  <h3 className="mr-1 text-sm text-gray-900">検索キー1</h3>
                                  <div className="w-1/10">
                                    <SelectFields
                                      id="searchKey1"
                                      color="indigo"
                                      value={userListResult.searchKey1}
                                      className={"h-10 w-48"}
                                      selectItems={searchKeysOneList}
                                      onChange={(e:any) => setUserListResult({...userListResult, searchKey1:e.target.value})}
                                    />
                                  </div>
                                </div>
                                <div className="flex ml-1 sm:items-center flex-wrap">
                                  <h3 className="mr-1 text-sm text-gray-900">検索キー2</h3>
                                  <div className="w-1/10">
                                    <SelectFields
                                      id="searchKey2"
                                      color="indigo"
                                      value={userListResult.searchKey2}
                                      className={"h-10 w-48"}
                                      selectItems={searchKeysTwoList}
                                      onChange={(e:any) => setUserListResult({...userListResult, searchKey2:e.target.value})}
                                    />
                                  </div>
                                </div>
                                <div className="flex ml-1 sm:items-center flex-wrap">
                                  <h3 className="mr-1 text-sm text-gray-900">検索キー3</h3>
                                  <div className="w-1/10">
                                    <SelectFields
                                      id="searchKey3"
                                      color="indigo"
                                      value={userListResult.searchKey3}
                                      className={"h-10 w-48"}
                                      selectItems={searchKeysThreeList}
                                      onChange={(e:any) => setUserListResult({...userListResult, searchKey3:e.target.value})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>                        
                        </tr> 
                        {/* 検索条件上段End */}

                        {/* 検索条件下段 */}
                        <tr className="min-w-full">
                          <td colSpan={2}>
                            <div className="flex min-w-full">
                              <div className="pl-3 mt-4 w-auto">
                                <div className="mt-3 flex sm:items-center justify-start flex-1 flex-wrap">
                                  <h3 className="text-sm text-gray-900">所属グループ</h3>
                                </div>
                              </div>
                              <div className="ml-1 mt-4 w-3/5">
                                <div className={`text-left items-start`}>
                                  <div className="h-12 w-full border-2 border-solid overflow-y-scroll">
                                    {userListResult.topic.map(
                                      (item: any, index) => (
                                        <Badge
                                          color="blue"
                                        >
                                          {item.title}
                                        </Badge>
                                      ))
                                    }
                                  </div>
                                </div>
                                <GroupSelectModal
                                  open={isOpenGroupSelect}
                                  toggle={toggle}
                                  closeOnClickOutside
                                  companyGroupsValue={companyGroupsValue}
                                  setState={setCompanyGroupsValue}
                                  children={undefined}
                                  dispButtonFlg={true}
                                  onSelectCancel={onSelectCancel}
                                  errorMessage={groupSelectError}
                                />
                              </div>
                              <div className="ml-1 mt-4 w-auto">
                                <div className="flex justify-start">
                                  <Button
                                    className={"h-12 w-24 mr-2 pl-4 pr-4 text-sm sm:items-center rounded-full"}
                                    onClick={toggle}
                                    children={"グループ選択"}
                                  />
                                </div>
                              </div>
                            </div>
                            <h3 className="text-xs text-gray-500 ml-[100px]">複数選択した場合いずれかに所属する利用者すべてが検索されます</h3>
                          </td>
                          <td colSpan={2}>
                            <div className="  flex min-w-full">
                              <div className="mt-2 flex justify-end min-w-full">
                                <div>
                                  <Button
                                    className={"h-10 text-sm sm:items-center"}
                                    onClick={onClickSearch}
                                    children={"検索　　　　"}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                       {/* 検索条件下段end */}
                      </table>
                    </div>
                    </>
                  ):(
                    <>
                    </>
                  )}
                </div>
              </div>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}